<template>
  <div class="wrapp">
    <div class="head-bar">
      <Nav></Nav>
    </div>
    <div class="content flex flex-direction justify-center align-center">
      <img src="../assets/img/404.png" alt />
      <div>您的选片链接已经失效，请联系客服获取新的连接</div>
    </div>
  </div>
</template>

<script>
import Nav from "../components/nav.vue";

export default {
  components: { Nav }
};
</script>

<style lang='scss' scoped>
.wrapp {
  .head-bar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 10;
    min-width: $min-width;
  }
  .content {
    padding-top: 80px;
    background: $bg-grey;
    height: 100vh;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: rgba(27, 36, 49, 1);
    line-height: 100px;
    img {
      width: 800px;
    }
  }
}
</style>